var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5302_36018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 19.3333H16.3333V15.9834C18.0178 15.8161 19.3333 14.3953 19.3333 12.6667C19.3333 10.8256 17.8411 9.3334 16 9.3334C14.1589 9.3334 12.6667 10.8256 12.6667 12.6667C12.6667 14.3953 13.9821 15.8161 15.6667 15.9834V19.3333H10.6667V0.333319C10.6667 0.149218 10.5174 0 10.3334 0H0.999996C0.815895 0 0.666677 0.149257 0.666677 0.333319V19.3333H0.333319C0.149218 19.3333 0 19.4826 0 19.6666C0 19.8507 0.149218 20 0.333319 20H19.6666C19.8507 20 19.9999 19.8507 19.9999 19.6666C19.9999 19.4826 19.8507 19.3333 19.6666 19.3333ZM13.3333 12.6667C13.3333 11.1938 14.527 10 15.9999 10C17.4728 10 18.6666 11.1937 18.6666 12.6667C18.6666 14.0266 17.6487 15.1478 16.3333 15.3119V14.1381L17.2357 13.2357C17.3658 13.1055 17.3658 12.8944 17.2357 12.7643C17.1055 12.6341 16.8945 12.6341 16.7643 12.7643L16 13.5286L15.2357 12.7643C15.1055 12.6341 14.8945 12.6341 14.7643 12.7643C14.6341 12.8944 14.6341 13.1055 14.7643 13.2357L15.6667 14.1381V15.3119C14.3512 15.1478 13.3333 14.0266 13.3333 12.6667ZM6.99997 19.3332H4.3333V16.6666H6.99997V19.3332ZM1.33332 0.666677H9.99996V19.3333H7.66665V16.3333C7.66665 16.1492 7.51743 16 7.33333 16H4.00002C3.81592 16 3.6667 16.1492 3.6667 16.3333V19.3333H1.33332V0.666677Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54426 13.3337H7.29428C7.40934 13.3337 7.5026 13.1782 7.5026 12.9864V9.5142C7.5026 9.32243 7.40934 9.16699 7.29428 9.16699H3.54426C3.4292 9.16699 3.33594 9.32243 3.33594 9.5142V12.9864C3.33591 13.1782 3.4292 13.3337 3.54426 13.3337ZM3.75259 9.86142H7.08593V12.6392H3.75259V9.86142Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54426 6.66667H7.29428C7.40934 6.66667 7.5026 6.51123 7.5026 6.31945V2.84721C7.5026 2.65544 7.40934 2.5 7.29428 2.5H3.54426C3.4292 2.5 3.33594 2.65544 3.33594 2.84721V6.31945C3.33591 6.51123 3.4292 6.66667 3.54426 6.66667ZM3.75259 3.19442H7.08593V5.97224H3.75259V3.19442Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5302_36018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.987decf593a699f0c6d58650dd4e59a0.svg";
export { ForwardRef as ReactComponent };